'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileOverview
 * @author Donny
 */
/**
 * @return {Object}               [生成的action]
 */
var domainNameMatch = function domainNameMatch(env, type) {
  if (['DEV', 'DAILY', 'PRE', 'PROD'].indexOf(type.toUpperCase()) === -1) {
    throw new Error('env param error. Please use dev, daily, pre, prod as keys');
  }
  if (typeof env === 'string') {
    if (window.location.hostname.indexOf(env) > -1) {
      return type.toUpperCase();
    }
  } else if (typeof env === 'function') {
    if (env()) {
      return type.toUpperCase();
    }
  }
  return undefined;
};

/**
 * 提供一个能够判断当前环境的工具库
 * 请提供三个入参daily, pre, prod作为判断环境的方式
 * 入参可以为string或function
 * 当为string时，会匹配域名
 * 当为function时会调用函数，函数返回值为true时代表环境判断结果为真
 */
var envInfo = exports.envInfo = function envInfo(envs) {
  if ((typeof envs === 'undefined' ? 'undefined' : _typeof(envs)) !== 'object') {
    throw new Error('env param error. need Object');
  }
  var _env = void 0;
  var _c = 0;
  for (var key in envs) {
    var value = envs[key];
    var r = domainNameMatch(value, key);
    if (r) {
      _env = r;
      _c += 1;
    }
  }
  if (_c > 1) {
    throw new Error('match multi env.');
  } else if (_c === 0) {
    throw new Error('match no env.');
  }
  return {
    getEnv: function getEnv() {
      return _env;
    },
    isDev: function isDev() {
      return _env === 'DEV';
    },
    isDaily: function isDaily() {
      return _env === 'DAILY';
    },
    isPre: function isPre() {
      return _env === 'PRE';
    },
    isProd: function isProd() {
      return _env === 'PROD';
    },
    isNotDev: function isNotDev() {
      return _env !== 'DEV';
    },
    isNotDaily: function isNotDaily() {
      return _env !== 'DAILY';
    },
    isNotPre: function isNotPre() {
      return _env !== 'PRE';
    },
    isNotProd: function isNotProd() {
      return _env !== 'PROD';
    },
    isDevOrDaily: function isDevOrDaily() {
      return _env === 'DEV' || _env === 'DAILY';
    },
    isNotDevOrDaily: function isNotDevOrDaily() {
      return _env !== 'DEV' && _env !== 'DAILY';
    }
  };
};

exports.default = envInfo;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_alipic-utils@0.0.2@@ali/alipic-utils/lib/envInfo.js
// module id = 263
// module chunks = 6